import { render, staticRenderFns } from "./PageLock.vue?vue&type=template&id=4757bca0&"
import script from "./PageLock.vue?vue&type=script&lang=js&"
export * from "./PageLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports